<template>
  <DBox
    :id="'cmp-catalog-releases-sidewindow-related_products'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add_new')} ${$t('related_product')}`"
    @add_click="onAddRelatedProduct"
  >
    <NTable
      class="dbox1"
      id="catalog-releases-sidewindow-related_products"
      :config="tableConfig"
      :headers="Headers"
      :items="list"
      :showNoItems="false"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td @click="onProductClick(item)" v-bind="tdcon('related_products')">
            <div class="related_products_status">
              <span
              :title="item['label_status_name']"
                class="circle-status"
                :style="{
                  backgroundColor: `#${item['label_status_colour']}`,
                }"
              ></span>
              <span class="ut-link ut-text-accent5">{{
              item["catalog_no"]
            }}</span>
            </div>
          
         
          </td>
          
          <td v-bind="tdcon('format')">
            <span>{{ item["format_name"] }}</span>
          </td>
          <td v-bind="tdcon('barcode')">
            <span>{{ item["barcode"] }}</span>
          </td>
          <td v-bind="tdcon('release_artist')">
            <span>{{ item["release_artist"] }}</span>
          </td>
          <td v-bind="tdcon('release_title')">
            <span>{{ item["release_title"] }}</span>
          </td>
          <td v-bind="tdcon('product_date')">
            <span>{{ item["product_date"] }}</span>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";
import { productsListLDTRoutes } from "../../router/routes";

export default {
  props: {
    selectedReleaseDetails: {
      type: Object
    }
  },
  components: {
    NTable,
    DBox
  },
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },
      releaseArtist: "",
      releaseTitle: "",
      releaseDate: "",
      releaseCode: "",
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      })
    };
  },
  computed: {
    Headers: function() {
      return [
        createTableHeader("related_products", {mw:150 ,}),
        createTableHeader("format", {mw:150}),
        createTableHeader("barcode", {mw:150}),
        createTableHeader("artist", {}),
        createTableHeader("ds_title", {}),
        createTableHeader("product_date", {mw:120})
      ];
    },

    list: function() {
      return this.selectedReleaseDetails.related_products || [];
    }
  },

  methods: {
    onTextFieldValueChange: function() {},
    getConcatVersion:function(item){
      if(item.version && item.version.length>0){
        if(item.alt_title)
        {
          return `${item['alt_title']} (${item['version']})`;
        }
        return `${item['release_title']} (${item['version']})`;
      }else{
        if(item.alt_title)
        {
          return `${item['alt_title']}`;
        }
        return `${item['release_title']}`;

      }

      return '';
    },
    onDropdownChange: function(item, e) {
      console.log("ITEM GENRE ENK", e);
      const payload = {
        name: "genre_relation_rank",
        value: e.value,
        item: item
      };

      this.$emit("change", payload);
    },
    onDateChange: function() {},
    deleteFile: function(item) {
      const payload = {
        file_id: item.file_id,
        file_relation_id: item.file_relation_id
      };
      this.$emit("delete", payload);
      console.log("Genres", item);
    },
    onAddRelatedProduct: function() {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_related_product",
          external_id: this.selectedReleaseDetails.release.release_id
        }
      });
    },

    onProductClick: function(item) {
      console.log(productsListLDTRoutes);
      this.$router.push({
        name: "products/product_id/tab",
        params: {
          product_id: item.product_id,
          tab: "overview"
        }
      });
      setTimeout(() => {
        this.$router.push({
          name: "products/product_id/tab",
          params: {
            product_id: item.product_id,
            tab: "overview"
          }
        });
      }, 1000);

      // this.$router.push({
      //   name: productsListLDTRoutes.names.tab,
      //   params: {
      //     product_id: item.product_id,
      //     tab: "overview",
      //   },
      // });
      // this.$router.push({
      //   name: productsListLDTRoutes.names.tab,
      //   params: { product_id: item.product_id },
      //   query: { tab: "overview" },
      // });
    }
  }
};
</script>
<style lang="scss">
.catalog-releases-sidewindow-related_products {
  .related_products div {
    flex: 1;
    display: flex;
    align-items: center;
    .related_products_status {
      display: flex;
      align-items: center;
      // max-width: 150px;
      .circle-status {
        margin-right: 10px;
        //border: 1px solid rgb(168, 168, 168);
      }
      .status-name {
        flex: 1;
      }
    }
  }
}
</style>